import { mapState, mapActions } from "vuex";
import CustomSideBarAppModal from "@/components/CustomSideBarAppModal";
import AppModal from "@/components/AppModal";
import AppIcon from "@/components/AppIcon";
import AppButton from "@/components/AppButton";
import AppButtonRadioGroup from "@/components/AppButtonRadioGroup";
import { country_codes, country_codes_flipped } from "@/utils/countries";
import AppForm from "@/components/AppForm";
import AppSelect from "@/components/AppSelect";
import ValidateMixin from "@/mixins/ValidateMixin.vue";
import { useVuelidate } from "@vuelidate/core";
export default {
  name: "AdvertisingAccountSideBar",
  emits: ["update:modelValue"],
  mixins: [ValidateMixin],
  components: {
    CustomSideBarAppModal,
    AppIcon,
    AppModal,
    AppButton,
    AppButtonRadioGroup,
    AppForm,
    AppSelect
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  data() {
    return {
      form: {
        region: "",
        country: "",
        account_provider: "Amazon Seller Central"
      },
      accountTypeOptions: [{
        text: "Seller account",
        value: "Amazon Seller Central"
      }, {
        text: "Vendor account",
        value: "Amazon Vendor Central"
      }],
      regions: [{
        text: "Choose a region to connect",
        value: ""
      }, {
        text: "North America",
        value: "North America"
      }, {
        text: "Europe & Middle East",
        value: "Europe & Middle East"
      }, {
        text: "Far East",
        value: "Far East"
      }],
      countries: {
        "": [{
          text: "Choose a country",
          value: ""
        }],
        "North America": [{
          text: "Brazil",
          value: "Brazil"
        }, {
          text: "US",
          value: "US"
        }, {
          text: "Mexico",
          value: "Mexico"
        }, {
          text: "Canada",
          value: "Canada"
        }],
        "Europe & Middle East": [{
          text: "Spain",
          value: "Spain"
        }, {
          text: "Belgium",
          value: "Belgium"
        }, {
          text: "UK",
          value: "UK"
        }, {
          text: "France",
          value: "France"
        }, {
          text: "Netherlands",
          value: "Netherlands"
        }, {
          text: "Germany",
          value: "Germany"
        }, {
          text: "Italy",
          value: "Italy"
        }, {
          text: "Sweden",
          value: "Sweden"
        }, {
          text: "Egypt",
          value: "Egypt"
        }, {
          text: "Poland",
          value: "Poland"
        }, {
          text: "Turkey",
          value: "Turkey"
        }, {
          text: "Saudi Arabia",
          value: "Saudi Arabia"
        }, {
          text: "U.A.E",
          value: "U.A.E"
        }, {
          text: "India",
          value: "India"
        }, {
          text: "Ireland",
          value: "Ireland"
        }],
        "Far East": [{
          text: "Singapore",
          value: "Singapore"
        }, {
          text: "Australia",
          value: "Australia"
        }, {
          text: "Japan",
          value: "Japan"
        }]
      }
    };
  },
  computed: {
    ...mapState({
      me: state => state.auth.me,
      isOmnyWorkspace: state => state.workspace.isOmnyWorkspace,
      current_workspace: state => state.workspace.current_workspace
    }),
    modal: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      }
    },
    getCountries() {
      return this.countries[this.form.region];
    }
  },
  methods: {
    ...mapActions(["accountAuthorize"]),
    onRegionChange() {
      this.form.country = "";
    },
    async onSubmit() {
      const valid = await this.mValidate();
      if (valid) {
        this.form.workspace_id = this.current_workspace.workspace_id;
        this.loading = true;
        await this.accountAuthorize(this.form);
        this.loading = false;
        this.modal = false;
      }
    }
  }
};